const shuffleArray = (array) => {
  for (var i = 0; i < array.length; i++) {
    const j = Math.floor(Math.random() * (i + 1));
    [array[i], array[j]] = [array[j], array[i]];
  }
};

export default shuffleArray;



// WEBPACK FOOTER //
// ./src/util/shuffle_array.js